import React from 'react';
import { Link } from 'react-router-dom';

import HeaderContainer from 'carbon-components-react/lib/components/UIShell/HeaderContainer';
import {
  Header,
  HeaderMenuButton,
  HeaderName,
  HeaderNavigation,
  HeaderMenuItem,
  HeaderSideNavItems,
  SkipToContent,
  SideNav,
  SideNavItems,
  HeaderMenu
} from 'carbon-components-react/lib/components/UIShell';

const PageHeader = (isSideNavExpanded, onClickSideNavExpand) => (
  <HeaderContainer
    render={({ isSideNavExpanded, onClickSideNavExpand }) => (
      <>
        <Header aria-label="">
          <SkipToContent />
          <HeaderMenuButton
            onClick={onClickSideNavExpand}
            isActive={isSideNavExpanded}
            aria-label=""
          />
          <HeaderName element={Link} to="/" prefix="HAXP">
            Workshop Series
          </HeaderName>
          <HeaderNavigation aria-label="">
            <HeaderMenuItem element={Link} to="/2026">
              2026
            </HeaderMenuItem>
            <HeaderMenu aria-label="previous" menuLinkName="Previous Iterations">
              <HeaderMenuItem element={Link} to="/2025">HAXP 2025</HeaderMenuItem>
              <HeaderMenuItem element={Link} to="/2024">HAXP 2024</HeaderMenuItem>
              <HeaderMenuItem element={Link} to="/2023">HAXP 2023</HeaderMenuItem>
              <HeaderMenuItem element={Link} to="/2022">XAIP 2022</HeaderMenuItem>
              <HeaderMenuItem element={Link} to="/2021">XAIP 2021</HeaderMenuItem>
              <HeaderMenuItem element={Link} to="/2020">XAIP 2020</HeaderMenuItem>
            </HeaderMenu>
            <HeaderMenuItem element={Link} to="/archive">
              Archive
            </HeaderMenuItem>
            <HeaderMenuItem element={Link} to="/overview">
              Overview
            </HeaderMenuItem>
            <HeaderMenuItem element={Link} to="/software">
              Software
            </HeaderMenuItem>
          </HeaderNavigation>
          <SideNav
            aria-label=""
            expanded={isSideNavExpanded}
            isPersistent={false}>
            <SideNavItems>
              <HeaderSideNavItems>
                <HeaderMenuItem element={Link} to="/">
                  Home
                </HeaderMenuItem>
                {/*
                <HeaderMenuItem element={Link} to="/team">
                  Team
                </HeaderMenuItem>
                 */}
                <HeaderMenuItem element={Link} to="/2025">
                  2025
                </HeaderMenuItem>
                <HeaderMenuItem element={Link} to="/2024">
                  2024
                </HeaderMenuItem>
                  <HeaderMenuItem element={Link} to="/2023">
                  2023
                </HeaderMenuItem>
                <HeaderMenuItem element={Link} to="/2022">
                  2022
                </HeaderMenuItem>
                <HeaderMenuItem element={Link} to="/2021">
                  2021
                </HeaderMenuItem>
                <HeaderMenuItem element={Link} to="/2020">
                  2020
                </HeaderMenuItem>
                <HeaderMenuItem element={Link} to="/explore">
                  Explore
                </HeaderMenuItem>
                <HeaderMenuItem element={Link} to="/landscape">
                  Landscape
                </HeaderMenuItem>
                <HeaderMenuItem element={Link} to="/software">
                  Software
                </HeaderMenuItem>
              </HeaderSideNavItems>
            </SideNavItems>
          </SideNav>
        </Header>
      </>
    )}
  />
);

export default PageHeader;
